import { useCartPricing } from '../contexts/CartPricingContext';
import { partnerFreeTrialInCart } from '../lib/gwpFreeTrial';

/**
 * The free months a GwP partner's code gives the Mini in the cart, or null. They come from the partner's free-trial
 * coupon on a regular plan, and the partner offers them as a gift, so the shop words them as "N months free".
 */
export default function useCartGwpPartnerFreeMonths(): number | null {
  return partnerFreeTrialInCart(useCartPricing())?.months ?? null;
}
